export default "__VITE_ASSET__mfq_LcnL__"